import { render, staticRenderFns } from "./emailShare.vue?vue&type=template&id=30cb76f2&scoped=true&"
import script from "./emailShare.vue?vue&type=script&lang=js&"
export * from "./emailShare.vue?vue&type=script&lang=js&"
import style0 from "./emailShare.vue?vue&type=style&index=0&id=30cb76f2&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cb76f2",
  null
  
)

export default component.exports